import Column from "@/Components/Grid/Column";
import Row from "@/Components/Grid/Row";
import GraphSrcSetImage from "../GraphSrcSetImage/GraphSrcSetImage";
import FrontText from "../../FrontText";
import sanitizeHTML from "@/Helpers/sanitizeHTML";

const AcfFeatures = ({ description, heading, image }) => {
    return (
        <Column className='xl:my-c120 lg:my-20 md:my-15 my-10'>
            <div className="bg-dark-blue-standard">
                <Row>
                    <Column xl={6} lg={6} md={6}>
                        <GraphSrcSetImage alt={heading} srcSet={image.srcSet} />
                    </Column>

                    <Column xl={4} lg={5} md={6} className='mx-auto justify-center flex flex-col py-14'>
                        <FrontText textSize='40/46' className="mb-6 text-white">
                            {sanitizeHTML(heading)}
                        </FrontText>

                        <FrontText textSize='16/20' className="text-white" spacings>
                            {sanitizeHTML(description)}
                        </FrontText>
                    </Column>
                </Row>
            </div>
        </Column>
    )
}

export default AcfFeatures;